import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { Outlet } from "react-router-dom";

import loadingSpinnerSvg from "../../assets/images/loading_spinner.svg";

class ProtectedRoute extends Component {

  render() {

    const {
      currentUser,
      loadingCurrentUser,
      allowedRoles
    } = this.props;

    /* console.log("************************")
    console.log("loadingCurrentUser:", loadingCurrentUser)
    console.log("currentUser:", currentUser)
    console.log("************************") */

    if (loadingCurrentUser) {
      return (
        
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <img
            src={loadingSpinnerSvg}
            alt="loading"
            style={{
              width: 120,
              height: 120
            }}
          />
        </div>
      );
    }

    if (!currentUser) {
      return <Navigate to="/error-403" replace />;
    }

    // vérification permissions
    const hasRole = allowedRoles.includes(currentUser.typeCompte)
    if (!hasRole) {
      return <Navigate to="/error-403" replace />;
    }

    return <Outlet />;
  }
}

//export default ProtectedRoute;

const mapStateToProps = ({ auth }) => {
  const {
    loadingCurrentUser,
    currentUser
  } = auth;

  return {
    loadingCurrentUser,
    currentUser
  }
};
export default connect(
  mapStateToProps,
  {
  }
)(ProtectedRoute);


